import React from "react";
import { useClickTracker } from "@xo-union/tk-component-analytics";
import { FullBleedContainer, TopLevelContainer, Row, Column } from "@xo-union/tk-component-grid";
import cx from "classnames";
import styles from "../../css/index.css";
import { ProductsSection, TheCompanySection, BrandsSection, HelpSection, BusinessSection, SocialSection } from "./components/sections/index.js";
import { TKBrandLogo, Heart } from "./components/graphicElements/index.js";
import AppDownload from "./components/AppDownload/index.js";
import { TKHostConsumer, TKHostProvider } from "./components/HostContext.js";
import ChatSection from "./components/sections/ChatSection/index.js";
const defaultRenderFooterLinks = () => /*#__PURE__*/React.createElement(BusinessSection, null);
const FooterNav = _ref => {
  let {
    analyticsProps,
    knotHostEnv = null,
    renderFooterLinks = defaultRenderFooterLinks
  } = _ref;
  const handleAnalyticsClick = useClickTracker({
    eventName: 'Footer Interaction',
    ...analyticsProps
  });
  return /*#__PURE__*/React.createElement(TKHostProvider, {
    env: knotHostEnv
  }, /*#__PURE__*/React.createElement(FullBleedContainer, {
    className: cx(styles.container)
  }, /*#__PURE__*/React.createElement(TopLevelContainer, {
    as: "nav",
    "aria-label": "Footer",
    onClick: handleAnalyticsClick
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    className: styles.logoColumn
  }, /*#__PURE__*/React.createElement(TKBrandLogo, {
    name: "theknot"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.madeWith
  }, "made with", /*#__PURE__*/React.createElement(Heart, {
    className: styles.heartIcon
  }))), /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    md: "12",
    lg: "6",
    xl: "8",
    className: styles.linksColumn
  }, /*#__PURE__*/React.createElement(Row, {
    className: styles.linksRow
  }, /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    md: "12",
    lg: "12",
    xl: "6"
  }, /*#__PURE__*/React.createElement(ProductsSection, null)), /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    md: "12",
    lg: "12",
    xl: "6",
    orderLg: "3",
    orderXl: "2"
  }, /*#__PURE__*/React.createElement(Row, {
    className: styles.rowColumns
  }, /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    md: "12",
    lg: "6"
  }, /*#__PURE__*/React.createElement(TheCompanySection, null)), /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    md: "12",
    lg: "6"
  }, /*#__PURE__*/React.createElement(BrandsSection, null), /*#__PURE__*/React.createElement(HelpSection, null))))), /*#__PURE__*/React.createElement(ChatSection, {
    hideInMobile: true
  })), /*#__PURE__*/React.createElement(Column, {
    xs: "12",
    md: "12",
    lg: "6",
    xl: "4",
    orderLg: "2",
    orderXl: "3"
  }, /*#__PURE__*/React.createElement(AppDownload, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-roledescription": "navigation level 2",
    "aria-label": "Other items"
  }, /*#__PURE__*/React.createElement("slot", {
    name: "footer-links"
  }, /*#__PURE__*/React.createElement(TKHostConsumer, null, host => renderFooterLinks({
    host
  })))), /*#__PURE__*/React.createElement(SocialSection, null)))));
};
export default FooterNav;